var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.46601 8.06475C1.7003 8.29904 1.93459 8.37275 2.39687 8.37275L7.46601 8.39961C7.51287 8.39961 7.55287 8.39961 7.57316 8.42618C7.59316 8.44618 7.59973 8.48646 7.59973 8.52675L7.61973 13.6027C7.62659 14.0647 7.7003 14.299 7.93459 14.5333C8.24944 14.8547 8.69144 14.8013 9.01944 14.4799C9.19373 14.3056 9.3343 14.0179 9.46144 13.7499L14.5843 2.70104C14.852 2.13875 14.8186 1.72332 14.5443 1.44875C14.276 1.18104 13.8609 1.14761 13.2986 1.41532L2.24944 6.53818C1.98144 6.66532 1.69373 6.80589 1.51944 6.98018C1.19801 7.30818 1.14459 7.74361 1.46601 8.06504",
    fill: "#196FAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPlane);
export default __webpack_public_path__ + "static/media/location-plane.baeecd88848abc74a1e6c3db03b35bb7.svg";
export { ForwardRef as ReactComponent };